export default __webpack_public_path__ + "static/media/Truck_Dry_Van_Icon.f151cafd.svg";